// import { ValidateEmailResponse } from "@parent-app/types";
import { ValidateEmailResponse, ValidateOrderResponse } from "src/shared/types/src";
import { getAxiosInstance } from "../api";

export const performAccountValidation = async ({ email }: { email: string }): Promise<ValidateEmailResponse> => {
    const { noRetryAxios } = getAxiosInstance();
    return noRetryAxios.post('/auth/validate-email', { email }).then((res) => {
        const response = res.data;
        if (response && response.status === "success") {
            return { accountActive: response.data.accountActive };
        }
        return { accountActive: false };
    });
}

export const sendVerificationCode = async ({ email, type, sessionId }: { email: string, type: string, sessionId?: string }): Promise<{ sessionId: string | null }> => {
    const { noRetryAxios } = getAxiosInstance();
    let reqBody: { email: string, type: string, sessionId?: string } = { email, type };
    if (sessionId)
        reqBody = { ...reqBody, sessionId };
    return noRetryAxios.post('/auth/send-otp', reqBody).then((res) => {
        const response = res.data;
        if (response && response.status === "success") {
            return { sessionId: response.data.sessionId };
        }
        return { sessionId: null };
    });
}

export const verifyOtp = async ({ email, sessionId, otp }: { email: string, sessionId: string, otp: string }): Promise<any> => {
    const { noRetryAxios } = getAxiosInstance();
    return noRetryAxios.post('/auth/verify-otp', { email, sessionId, otp }).then((res) => {
        console.log("response from verify otp : ", res, res.data);
        const response = res.data;
        if (response && response.status === "success") {
            return {
                sessionId: response.data.sessionId,
                username: response.data.username,
                label: response.data.accountActivationParams.text || ''
            };
        }
        return null;
    });
}

export const verifyMFA = async ({ email, sessionId, otp }: { email: string, sessionId: string, otp: string }): Promise<any> => {
    const { noRetryAxios } = getAxiosInstance();
    return noRetryAxios.post('/auth/login/verify-mfa', { email, sessionId, otp }).then((res) => {
        console.log("response from verify MFA : ", res, res.data);
        const response = res.data;
        if (response && response.status === "success") {
            return response.data;
        }
        return null;
    });
}

export const verifyDob = async ({ email, sessionId, dob }: { email: string, sessionId: string, dob: string }): Promise<any> => {
    const { noRetryAxios } = getAxiosInstance();
    return noRetryAxios.post('/auth/verify-dob', { email, sessionId, dob }).then((res) => {
        console.log("response from verify dob : ", res, res.data);
        const response = res.data;
        if (response && response.status === "success") {
            return {
                sessionId: response.data.sessionId,
                username: response.data.username
            };
        }
        return null;
    });
}

export const setNewPassword = async ({ email, sessionId, dob, otp, password, confirmPassword }: { email: string, sessionId: string, dob: string, otp: string, password: string, confirmPassword: string }): Promise<any> => {
    const { noRetryAxios } = getAxiosInstance();
    return noRetryAxios.post('/auth/set-password', { email, sessionId, dob, otp, password, confirmPassword }).then((res) => {
        console.log("response from set password : ", res, res.data);
        const response = res.data;
        if (response && response.status === "success") {
            return response.data;
        }
        return null;
    });
}

export const loginParent = async ({ email, password }: { email: string, password: string }): Promise<any> => {
    const { noRetryAxios } = getAxiosInstance();
    return noRetryAxios.post('/auth/login', { email, password }).then((res) => {
        console.log("response from login call : ", res, res.data);
        const response = res.data;
        if (response && response.status === "success") {
            return response.data;
        }
        return null;
    });
}

export const validateSession = async ({ refreshToken }: { refreshToken: string }): Promise<any> => {
    const { noRetryAxios } = getAxiosInstance();
    return noRetryAxios.post('/v2/auth', { refreshToken }).then((res) => {
        // console.log("response from auth call : ", res, res.data);
        const response = res.data;
        if (response && response.status === "success") {
            return response.data;
        }
        return null;
    });
}

export const updateAppTour = async ({ appTour }: { appTour: boolean }): Promise<any> => {
    const { noRetryAxios } = getAxiosInstance();
    return noRetryAxios.patch('/user/app-tour', { appTour }).then((res) => {
        // console.log("response from auth call : ", res, res.data);
        const response = res.data;
        if (response && response.status === "success") {
            return response.data;
        }
        return null;
    });
}

export const validateEymemoriesSession = async ({ accessToken }: { accessToken: string }): Promise<ValidateOrderResponse> => {
    const { eymemoriesAxios } = getAxiosInstance();
    return eymemoriesAxios.post('/eymemories/auth', { accessToken }, {
        headers: {
            Authorization: `Bearer ${accessToken}`
        }
    }).then((res) => {
        const response = res.data;
        if (response && response.status === "success") {
            return response.data;
        }
        return null;
    });
}
